/* eslint-disable react/no-array-index-key */

import React from 'react'
import { Circle, Svg, Text, Line } from 'react-native-svg'
import type { CircleProps } from 'react-native-svg'
import { getTheme } from '@hedgit/lib/theme/index'
interface DecoratorProps {
  x: (arg: number) => number;
  y: (arg: number) => number;
  data: number[];
  colorDots: string;
  colorLabel: string;
}

interface CircleSvgProps extends CircleProps {
  style: Record<string, string>;
}

const CircleSvg = (props: CircleSvgProps) => {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Circle {...props} />
}

export const Dots = (props: Partial<DecoratorProps>) => {
  const { x, y, data, colorDots, colorLabel } = props as DecoratorProps
  const theme = getTheme()

  const shadow = { filter: 'drop-shadow( 0px 3px 6px rgba(0, 0, 0, .16))' }
  return (
    <Svg>
      {data?.map((value, index) => (
        <Svg key={index}>
          <Text
            x={x(index)}
            y={y(value) - 12}
            fontWeight="600"
            fill={colorLabel}
            fontSize="10"
            fontFamily='lato'
            textAnchor='middle'
          >
            {value}
          </Text>
          <CircleSvg
            key={`${x(index) - y(index)}`}
            cx={x(index)}
            cy={y(value)}
            r={4.5}
            fill={colorDots}
            style={shadow}
          />
          <Line
            x1={x(index)}
            y1={y(value) + 5}
            x2={x(index)}
            y2={250}
            stroke={theme.colors.whiteMiddle}
            strokeDasharray="1.5"
            strokeWidth="1"
          />
        </Svg>
      ))}
    </Svg>
  )
}
